interface IconPressureProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconPressure
 */
const IconPressure = ({ size = 48, color = '#AE0A10', className }: IconPressureProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9700)">
      <path
        d="M24.5 6.58008C14.88 6.58008 7.07996 14.3801 7.07996 24.0001C7.07996 33.6201 14.88 41.4201 24.5 41.4201C34.12 41.4201 41.92 33.6201 41.92 24.0001C41.92 14.3801 34.12 6.58008 24.5 6.58008ZM25.92 25.4201C25.52 25.8201 25.02 26.0001 24.5 26.0001C23.98 26.0001 23.48 25.8001 23.08 25.4201L16.64 18.9801C15.86 18.2001 15.86 16.9401 16.64 16.1601C17.42 15.3801 18.68 15.3801 19.46 16.1601L25.9 22.6001C26.68 23.3801 26.68 24.6401 25.9 25.4201H25.92Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9700">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconPressure;
